import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineLeaseFee";

const url = "/api/machines/MachineLeaseFee";

export const machineLeaseFeeLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Lease Fee",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
